import axios from 'axios';
import { Post } from '@/service/request/server';
import { envConfig } from '../../../env';


// const cotton = 'https://server.cottongame.com/cotton'
const cotton = envConfig.formalServer + "/cotton"



//--- Role.vue
export const selInnerMemberByCondition = params => axios.post(cotton + '/selInnerMemberByCondition', params) // 获取内部人员信息
export function selInnerMemberDataByCondition(condition, ) {
    return Post(envConfig.formalServer + "/cotton/selInnerMemberByCondition", {condition, })
}
export const logicDelInnerUser = params => axios.post(cotton + '/logicDelInnerUser', params)                 // 删除人员 (逻辑)

export function insertRole(roleName) {
    return Post(envConfig.formalServer + "/cotton/insertRole", {roleName: roleName})
}

export function deleteRole(roleId) {
    return Post(envConfig.formalServer + "/cotton/deleteRole", {roleId: roleId})
}

export function updateRole(role) {
    return Post(envConfig.formalServer + "/cotton/updateRole", role)
}

export function selectRoleList(roleId, roleName, pageNum) {
    return new Promise((resolve, reject) => {
        Post(envConfig.formalServer + '/cotton/selectRoleList', {
            roleId,
            roleName,
            pageNum,
            pageSize: 9999
        }).then(result => {
            if (result.code !== 200) {
                resolve(result)
            }else {
                if (result.data) {
                    let groupArr = result.data.result
                    result.data.result = []
                    groupArr.forEach((group, index) => {
                        if (group.roleName !== '超级管理员') {
                            result.data.result.push(group)
                        }
                        if (index === result.data.result.length - 1) {
                            resolve(result)
                        }
                    })
                }else {
                    resolve(result)
                }
            }
        })
    })
}
